export const __ENVIRONMENT__: string = "production";
// Het versienummer komt uit de build: amplify.yml zet NEXT_PUBLIC_APP_VERSION op de
// commit die gebouwd wordt, en Next bakt die bij het bouwen in. Het stond hier eerder
// hard ingetypt en werd met de hand bijgewerkt door deploy.sh lokaal te draaien; sinds
// augustus 2023 deed niemand dat meer, dus toonde de footer twee jaar lang een commit
// die allang niet meer draaide.
export const __VERSION__: string =
    process.env.NEXT_PUBLIC_APP_VERSION ?? "1.1.dev";
export const __APP_NAME__: string = "Alexion CRM VM";
export const __API__URL__: string =
    "https://zn27krikfnc4jawigqafqovdtu.appsync-api.eu-central-1.amazonaws.com/graphql";
export const __DOWNLOAD_BASE_URL__: string = "https://files.alexion.nl";
